import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { LayoutComponent } from 'app/views/presentations/layouts/layout.component';
import { LayoutResolver } from 'app/views/presentations/layouts/layoutResolver';
import { PresentationModel } from 'app/views/presentations/models/presentation.model';

@Component({
    selector: 'psm-layout-selector',
    templateUrl: 'layoutSelector.component.html',
    styleUrls: ['layoutSelector.component.scss']
})

export class LayoutSelectorComponent implements OnInit {
    public get LayoutTypes() {
        if (!this.layoutResolver) { return []; }
        return this.layoutResolver.getSupportedComponentKeys();
    }
    private static readonly carouselWidth = 3;

    // Emits an array containing the [previousSectionId, newSectionId]
    private _sectionClicked: EventEmitter<[number, number]> = new EventEmitter();
    @Output() public get sectionClicked() { return this._sectionClicked; }

    private _layoutChanged: EventEmitter<string> = new EventEmitter();
    @Output() public get layoutClicked() { return this._layoutChanged; }

    @ViewChild('layout', { read: ViewContainerRef }) private layoutContainer: ViewContainerRef;
    private currentLayoutComponent: LayoutComponent;

    private _layout: string;
    @Input() public set layout(value: string) {
        this._layout = value;
        this.changeLayout(value);
    }

    private _sectionsTypes: string[];
    @Input() public set sectionsTypes(types: string[]) {
        this._sectionsTypes = types;
        if (this.currentLayoutComponent) {
            this.currentLayoutComponent.sectionsTypes = this._sectionsTypes;
        }
    }

    private _invalidSections: Set<number> = new Set<number>();
    @Input() public set invalidSections(sections: Set<number>) {
        this._invalidSections = sections;
        if (this.currentLayoutComponent) {
            this.currentLayoutComponent.invalidSections = this._invalidSections;
        }
    }

    public carouselStartId = 0;
    public get numberOfLayoutTypes() {
        return this.layoutResolver.getSupportedComponentKeys().length;
    }

    constructor(private layoutResolver: LayoutResolver) { }

    public ngOnInit() { }

    private changeLayout(type: string) {
        this.layoutContainer.clear();
        const factory = this.layoutResolver.resolveComponent(type);
        this.currentLayoutComponent = this.layoutContainer.createComponent(factory).instance as LayoutComponent;
        if (this.currentLayoutComponent) {
            this.currentLayoutComponent.sectionsTypes = this._sectionsTypes;
            this.currentLayoutComponent.invalidSections = this._invalidSections;
            this.currentLayoutComponent.sectionClicked.subscribe(ids => this._sectionClicked.emit(ids));
        }
    }

    public isLayoutVisible(id: number) {
        return this.carouselStartId <= id && id < this.carouselStartId + LayoutSelectorComponent.carouselWidth;
    }

    public moveCarouselLeft() {
        if (!this.canMoveCarouselLeft()) { return; }
        --this.carouselStartId;
    }

    public canMoveCarouselLeft() {
        return this.carouselStartId > 0;
    }

    public moveCarouselRight() {
        if (!this.canMoveCarouselRight()) { return; }
        ++this.carouselStartId;
    }

    public canMoveCarouselRight() {
        return this.carouselStartId + LayoutSelectorComponent.carouselWidth < this.numberOfLayoutTypes;
    }

    public emitLayoutClicked(layout: string) {
        this.layoutClicked.emit(layout);
    }
}


// WEBPACK FOOTER //
// ./src/app/views/presentations/layouts/layoutSelector.component.ts